module.exports = __webpack_public_path__ + "../resources/images/headshot-robin-92f57a928a48fbcd9067125a6bb1a48c.png";